var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "garage-list-page" } }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("h2", [
              _vm._v(
                "\n                    My Recommendation\n                "
              )
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm.total > 0
              ? _c("div", [
                  _c("strong", [_vm._v("Showing")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.from))]),
                  _vm._v("-"),
                  _c("span", [_vm._v(_vm._s(_vm.to))]),
                  _vm._v(" of "),
                  _c("span", [_vm._v(_vm._s(_vm.total))]),
                  _vm._v("\n                    results\n                ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("b-table", {
              staticClass: "list-table",
              attrs: {
                "sort-by": _vm.sort_by,
                "sort-desc": _vm.sort_desc,
                fields: _vm.fields,
                items: _vm.recommendation,
                "show-empty": ""
              },
              on: {
                "update:sortBy": function($event) {
                  _vm.sort_by = $event
                },
                "update:sort-by": function($event) {
                  _vm.sort_by = $event
                },
                "update:sortDesc": function($event) {
                  _vm.sort_desc = $event
                },
                "update:sort-desc": function($event) {
                  _vm.sort_desc = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "empty",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n                        No recommendations created by you.\n                    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(link)",
                  fn: function(data) {
                    return [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.$laravelRouter(
                              "recommended-vehicle.show",
                              data.item.id
                            )
                          }
                        },
                        [_vm._v("Click here")]
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _vm.total > 0
              ? _c("b-pagination", {
                  attrs: { "total-rows": _vm.total, "per-page": _vm.per_page },
                  model: {
                    value: _vm.current_page,
                    callback: function($$v) {
                      _vm.current_page = $$v
                    },
                    expression: "current_page"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sorting" }, [
      _c("div", { staticClass: "form-group inline-label" }, [
        _c("div", [
          _c("select", { attrs: { name: "sorting", id: "sorting" } }, [
            _c("option", { attrs: { value: "" } }, [
              _vm._v("Most Recently Used")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "" } }, [
              _vm._v("Most Recently Used")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "" } }, [
              _vm._v("Most Recently Used")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "" } }, [
              _vm._v("Most Recently Used")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f61ff60", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f61ff60","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/MyRecommendations/MyRecommendationPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4f61ff60","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/MyRecommendations/MyRecommendationPage.vue
// module chunks = 0